import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32dc45b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live_type_wrap" }
const _hoisted_2 = { class: "live_type_radio" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "live_type_radio_title" }, "内容状态：", -1))
const _hoisted_4 = { class: "live_type_content" }
const _hoisted_5 = { class: "live_type_content_menu" }
const _hoisted_6 = { class: "ltwm_item_main" }
const _hoisted_7 = { class: "search_input" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "ltwm_item_btn" }
const _hoisted_10 = { class: "mod_c_tbody live_type_content_main" }
const _hoisted_11 = { class: "operate_wrap" }
const _hoisted_12 = { class: "mod_search_form" }
const _hoisted_13 = { class: "operate_wrap_choose" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "content_square" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 4,
  class: "mod_pagin"
}

import CDelModal from '@/components/CDelModal.vue';
import { RootModal } from '@/components/CDelModal.vue';
import { ref, withDefaults, reactive, computed, unref, nextTick, inject } from 'vue';
import { Select, Dropdown, Menu, Pagination, Modal, Radio, message } from 'ant-design-vue';
import { SearchOutlined, MoreOutlined } from '@ant-design/icons-vue';
import LiveItemSquare from '@/components/liveItem/LiveItemSquare.vue';
import LiveItemBar from '@/components/liveItem/LiveItemBar.vue';
import { useStore } from 'vuex';
import type { RootLive, SearchLiveClass } from '@/store/modules/live/types';
import AppLink from '@/components/AppLink.vue';
import http from '@/api/live';
import { emptyDataSec } from '@/assets';
import ModalCreatePlace from './place/ModalCreateType.vue';
import { useDebounce } from '@/hooks/useDebounce';
import { ClientSize } from '@/App.vue';
import CLoading from '@/components/CLoading.vue';

interface IProps {
  viewSwitch?: boolean;
}
interface Options {
  label: string;
  value: number | '';
}
interface Condition {
  fileClass: Options[];
  allFileClass: Options[];
  fileClassStatus: Options[];
}
interface LiveAddForm {
  id?: number;
  file_name: string;
}

import { onMounted, onUnmounted } from 'vue';

const __default__ = {
  name: 'liveType',
};
export interface ILives {
  id: string;
  name: string;
  datetime: string;
  duration: number;
  liveType: string;
  liveCount: number;
}
export interface Imodal {
  title: string;
  visible: boolean;
  loading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    viewSwitch: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { viewSwitch: boolean };

const aModal = Modal;
const aSelect = Select;
const aDropdown = Dropdown;
const aMenu = Menu;
const aMenuItem = Menu.Item;
const aPagination = Pagination;
const aRadioGroup = Radio.Group;

// 视图切换按钮标识

// 选中模块
const selectKeys = ref({});
const getSelectIds = computed(() => {
  let selectArr = Array<any>();
  Object.keys(selectKeys.value).forEach((e) => {
    if (selectKeys.value[e] === true) {
      selectArr.push(e);
    }
  });
  return selectArr.join(',');
});
const getSelected = computed(() => Boolean(!getSelectIds.value));
const choice = ref(false);
const choice_all = ref(false);
const isChecked = computed(() => {
  return choice.value || choice_all.value;
});
const changeItemMarkAll = () => {
  if (choice_all.value === true) {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = true;
    });
  } else {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = false;
    });
  }
};
const changeSwitch = () => {
  if (choice.value === false) {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = false;
    });
  }
};
const changeItemMark = (item: ILives) => {
  selectKeys.value[item.id] = !selectKeys.value[item.id];
};

// 列表模块

// 请求模块
const condition = reactive<Condition>({
  fileClass: [],
  allFileClass: [],
  fileClassStatus: [
    { label: '全部', value: 0 },
    { label: '已分类', value: 1 },
    { label: '未分类', value: 2 },
  ],
});

const moveFileClass = computed(() => condition.allFileClass.filter((e) => e.value !== queryForm.file_class)); // 更换分类数组
const liveTypeForm = ref<Options[]>([]);
const moveLiveType = async () => {
  try {
    const formData = {
      old_file_class_id: queryForm.file_class,
      file_class_id: liveTypeForm.value,
      studio_str: getSelectIds.value,
    };
    const res = await http.studioMovesFolder(formData);
    message.success(res.data.message);
    liveTypeForm.value = [];
    selectKeys.value = {};
    getLiveList();
    choice.value = false;
    choice_all.value = false;
  } catch (err) {
    console.error(err);
  }
};

const typeSearch = reactive({
  visable: false,
  text: '',
});
const searchRef = ref();
const blurRef = ref();
const blurchange = (e) => {
  if (typeSearch.visable && !blurRef.value.contains(e.target)) {
    typeSearch.visable = false;
    typeSearch.text = '';
    changeSearch();
  }
};
onMounted(() => {
  document.addEventListener('click', blurchange);
});
onUnmounted(() => {
  document.removeEventListener('click', blurchange);
});
const showSearch = () => {
  if (!typeSearch.visable) {
    //全部分类文字时 显示搜索框 聚焦
    typeSearch.visable = true;
    nextTick(() => {
      unref(searchRef.value.input.focus());
    });
  } else {
    if (typeSearch.text) {
      changeSearch();
    } else {
      typeSearch.visable = false;
    }
  }
};
const changeSearch = () => {
  getCondition();
};

const getCondition = useDebounce(() => {
  condition.allFileClass = [
    {
      label: '默认分类',
      value: '',
    },
  ];
  http
    .getFileClassList({
      params: {
        file_class_name: typeSearch.text,
      },
    })
    .then((res) => {
      const resData = res.data.data;
      const cArr: Options[] = resData
        ? resData.map((e: any) => ({
            label: e.name,
            value: e.ide,
          }))
        : [];
      condition.fileClass = cArr;
      condition.allFileClass.push(...cArr);
    });
});
getCondition();

const store = useStore();
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 0, // 总页数
  options: ['12', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});
const queryForm = reactive<Partial<SearchLiveClass>>({
  // file_class: '',
  file_class_status: 0,
});

/**
 * 豆腐块获取数量计算
 * 三级菜单使用自定义宽度 且 最小宽对应当前组件样式宽度
 */
const baseSize = inject('ClientSize') as ClientSize;
const getItemCount = () => {
  const minWidth = baseSize.width > 1920 ? 270 : 226; // 对应当前组件样式
  const wrapWidth = baseSize.width - baseSize.menuSize - 265;
  let itemWidth = 0;
  let baseNum = 3;
  const gap = 16; // 间距
  let testkey = 0;
  let lastItemWidth = 0;
  let lastBaseNum = 0;
  do {
    lastItemWidth = itemWidth;
    lastBaseNum = baseNum;
    const countNum = (((wrapWidth - (baseNum - 1) * gap) / baseNum) * 100).toString();
    itemWidth = parseFloat((parseInt(countNum) / 100).toFixed(2));
    baseNum = baseNum + 1;
    testkey++;
  } while (itemWidth >= minWidth);
  const rowCount = lastBaseNum - 1;
  const itemHeight = parseFloat((((lastItemWidth - 2) * 5625) / 10000 + 80).toFixed(2));
  let columnCount = Math.ceil((baseSize.height - 400) / itemHeight);
  let resCount = rowCount * columnCount;
  while (resCount < 9) {
    columnCount += 1;
    resCount = rowCount * columnCount;
  }
  for (let i = 0; i < 5; i++) {
    pageConfig.options[i] = (resCount * (i + 1)).toString();
  }
  return resCount;
};
pageConfig.pageSize = getItemCount();

const showLoading = ref(false);
const getLiveList = useDebounce(async (pageData?: { current: number }) => {
  showLoading.value = false;
  const { current, pageSize } = pageConfig;
  const search = {
    page: pageData?.current ?? current,
    page_num: pageSize,
    status_order: 1,
    ...queryForm,
  };
  const { current_page, total, data } = await store.dispatch('live/getLiveList', search);
  showLoading.value = true;
  selectKeys.value = {};
  data.map((e: RootLive) => {
    selectKeys.value[e.id] = false;
  });
  pageConfig.current = current_page;
  pageConfig.totalSize = total;
});
getLiveList();
const liveList = computed(() => store.state.live.liveList);

// 切换分类
const fileClassKey = ref<number | ''>('');
const changeType = (id: number | '') => {
  fileClassKey.value = id;
  queryForm.file_class = id;
  getLiveList();
};

//  modal
const addModalType = ref(true);
const fromData = ref<LiveAddForm>({
  file_name: '',
});
const createModal = reactive<RootModal>({
  title: '添加分类',
  visible: false,
  loading: false,
});
const resetCreateModal = () => {
  fromData.value = {
    file_name: '',
  };
  createModal.title = '添加分类';
  createModal.visible = false;
  createModal.loading = false;
};
const openCreateModal = (index?: any) => {
  if (index !== void 0 && index !== 'add') {
    createModal.title = '修改分类';
    addModalType.value = false;
    fromData.value = {
      id: condition.fileClass[index].value as number,
      file_name: condition.fileClass[index].label,
    };
  }
  if (index == 'add') {
    addModalType.value = true;
  }
  createModal.visible = true;
};
const createFolder = useDebounce(async () => {
  try {
    createModal.loading = true;
    if (addModalType.value) {
      await http.addFolderFile(fromData.value);
    } else {
      await http.updFolderFile(fromData.value);
    }
    fileClassKey.value = '';
    getCondition();
    resetCreateModal();
    message.success('操作成功');
  } catch (err: any) {
    message.error(err?.data?.error);
    createModal.loading = false;
  }
});

// 删除
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});
const delId = ref(0);
const openDelModal = (index: number) => {
  delModal.visible = true;
  delId.value = condition.fileClass[index].value as number;
};
const closeDelModat = () => {
  delModal.visible = !delModal.visible;
};
const removeLiveData = () => {
  delModal.loading = true;
  http
    .delFolderFile({ file_class_id: delId.value })
    .then(() => {
      message.success('操作成功');
      getCondition();
    })
    .finally(() => {
      delModal.loading = false;
      delModal.visible = false;
      delId.value = 0;
    });
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(aRadioGroup), {
          class: "live_type_radio_item",
          options: condition.fileClassStatus,
          value: queryForm.file_class_status,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.file_class_status) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(getLiveList)({ current: 1 })))
        }, null, 8, ["options", "value"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            ref_key: "blurRef",
            ref: blurRef,
            class: _normalizeClass(["ltwm_item list", { actived: fileClassKey.value === '' }])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_input, {
                  ref_key: "searchRef",
                  ref: searchRef,
                  value: typeSearch.text,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((typeSearch.text) = $event)),
                  onPressEnter: changeSearch,
                  class: "ltcm_input"
                }, null, 8, ["value"])
              ], 512), [
                [_vShow, typeSearch.visable]
              ]),
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (changeType('')))
              }, [
                _withDirectives(_createElementVNode("span", { onChange: blurchange }, "全部分类", 544), [
                  [_vShow, !typeSearch.visable]
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "ltwm_item_btn",
              onClick: showSearch
            }, [
              _createVNode(_unref(SearchOutlined), { class: "opera_btn" })
            ])
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(condition.fileClass, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.value,
              class: _normalizeClass(["ltwm_item list", { actived: fileClassKey.value === item.value }])
            }, [
              _createElementVNode("div", {
                class: "ltwm_item_main",
                onClick: ($event: any) => (changeType(item.value))
              }, _toDisplayString(item.label), 9, _hoisted_8),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(aDropdown), { trigger: ['click'] }, {
                  overlay: _withCtx(() => [
                    _createVNode(_unref(aMenu), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(aMenuItem), {
                          key: "0",
                          onClick: ($event: any) => (openCreateModal(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 重命名 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_unref(aMenuItem), {
                          key: "1",
                          onClick: ($event: any) => (openDelModal(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 删除分类 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "opera_btn",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                    }, [
                      _createVNode(_unref(MoreOutlined), { class: "icon" })
                    ])
                  ]),
                  _: 2
                }, 1024)
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_button, {
                class: "mod_search_form_func",
                type: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (openCreateModal('add')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加分类")
                ]),
                _: 1
              }),
              _createVNode(_unref(aSelect), {
                class: "list_file_class mod_select",
                placeholder: "更换分类",
                value: liveTypeForm.value,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((liveTypeForm).value = $event)),
                options: _unref(moveFileClass),
                disabled: _unref(getSelected),
                onChange: moveLiveType
              }, {
                suffixIcon: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    class: "mod_select_icon",
                    "icon-class": "list_select"
                  })
                ]),
                _: 1
              }, 8, ["value", "options", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_a_checkbox, {
                class: "checkbox",
                checked: choice.value,
                "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((choice).value = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (changeSwitch()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("选择")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_component_a_checkbox, {
                class: "checkbox",
                checked: choice_all.value,
                "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((choice_all).value = $event)),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (changeItemMarkAll()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("全选")
                ]),
                _: 1
              }, 8, ["checked"])
            ])
          ]),
          (props.viewSwitch)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(liveList), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createVNode(AppLink, {
                        to: `/live_set/${item.id}/broad_cast_control`,
                        disable: _unref(isChecked)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(LiveItemSquare, {
                            "data-source": item,
                            choice: _unref(isChecked),
                            selected: selectKeys.value[item.id],
                            "onSelect:changeItemMark": changeItemMark
                          }, null, 8, ["data-source", "choice", "selected"])
                        ]),
                        _: 2
                      }, 1032, ["to", "disable"])
                    ]))
                  }), 128))
                ])
              ], 512)), [
                [_vShow, showLoading.value]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_a_row, { gutter: [24, 24] }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(liveList), (item) => {
                      return (_openBlock(), _createBlock(_component_a_col, {
                        key: item.id,
                        class: "gutter-row",
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(AppLink, {
                            to: `/live_set/${item.id}/broad_cast_control`,
                            disable: _unref(isChecked)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(LiveItemBar, {
                                "data-source": item,
                                choice: _unref(isChecked),
                                selected: selectKeys.value[item.id],
                                "onSelect:changeItemMark": changeItemMark,
                                QRCode: !_unref(isChecked)
                              }, null, 8, ["data-source", "choice", "selected", "QRCode"])
                            ]),
                            _: 2
                          }, 1032, ["to", "disable"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ], 512)), [
                [_vShow, showLoading.value]
              ]),
          (!showLoading.value)
            ? (_openBlock(), _createBlock(CLoading, { key: 2 }))
            : _createCommentVNode("", true),
          (showLoading.value && _unref(liveList).length === 0)
            ? (_openBlock(), _createBlock(_component_a_empty, {
                key: 3,
                class: "empty_wrap",
                image: _unref(emptyDataSec),
                description: "页面暂无数据信息~"
              }, null, 8, ["image"]))
            : _createCommentVNode("", true),
          (showLoading.value && _unref(liveList).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_unref(aPagination), {
                  "show-quick-jumper": "",
                  total: pageConfig.totalSize,
                  current: pageConfig.current,
                  "onUpdate:current": _cache[11] || (_cache[11] = ($event: any) => ((pageConfig.current) = $event)),
                  "page-size": pageConfig.pageSize,
                  "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((pageConfig.pageSize) = $event)),
                  pageSizeOptions: pageConfig.options,
                  "show-less-items": "",
                  "show-size-changer": "",
                  onChange: _unref(getLiveList),
                  onShowSizeChange: _unref(getLiveList)
                }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_unref(aModal), {
      visible: createModal.visible,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((createModal.visible) = $event)),
      title: createModal.title,
      onOk: _cache[16] || (_cache[16] = ($event: any) => (openCreateModal())),
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (resetCreateModal()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          loading: createModal.loading,
          onClick: _unref(createFolder)
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(ModalCreatePlace, {
          modelValue: fromData.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((fromData).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      close: closeDelModat,
      ok: removeLiveData,
      loading: delModal.loading
    }, null, 8, ["visible", "loading"])
  ], 64))
}
}

})